export default function exportToPdf(app: any, options?: any) {
    gd.modals.export.exportToPdf(_.assign({
        app             : app,

        // for gantt
        dateRange       : app.manager?.dateRangeManager?.defaultExportDates(),
        dateRangeLimits : app.manager?.dateRangeManager?.getDateRange(),
    }, options))
}